module.exports = __webpack_public_path__ + "img/spinner.9024c67.svg";